/**
 * useChronoAlertSounds — les deux sons du chrono de l'ancien `TimerContainer` : bientôt la durée prévue
 * (95 %), puis la durée dépassée (101 %), chacun à la seconde où le chrono qui court franchit son seuil
 * (`chronoAlertsAhead`). Le chrono décompte seul dans `<ActivityChrono>` : ici, un minuteur par seuil
 * encore devant, reposé à chaque changement du chrono (une pause, une reprise, le temps relu du
 * serveur) et retiré quand il s'arrête.
 *
 * Les bandeaux qui accompagnaient ces sons (« Tu as bientôt atteint / dépassé la durée prévue ») ne sont
 * pas posés : 95 % se lit à la tinte du chrono, la durée dépassée à son temps sous zéro.
 */
import { useEffect } from "react"

import { chronoAlertsAhead } from "../../../../../../engine/activity/chrono"
import { type UIActivityChrono } from "../../../types/studentActivity"
import { playStudentSound } from "../studentSounds"
import { CHRONO_ALERT_SOUNDS } from "./activitySounds"

export function useChronoAlertSounds(chrono: UIActivityChrono, inLive: boolean): void {
    const { remainingSeconds, estimatedSeconds, paused = false, runningSince = null } = chrono
    useEffect(() => {
        const timers = chronoAlertsAhead({ remainingSeconds, estimatedSeconds, paused, runningSince }, Date.now()).map(
            ({ alert, inMs }) => setTimeout(() => playStudentSound(CHRONO_ALERT_SOUNDS[alert], inLive, alert), inMs)
        )
        return () => timers.forEach(clearTimeout)
    }, [remainingSeconds, estimatedSeconds, paused, runningSince, inLive])
}
